import type { InvitationAcceptance } from './auth'

/**
 * Where the browser goes after accepting an invitation (ADR-20260930 D7).
 * When the accept answer names the organisation joined, the session first
 * moves there (POST /v1/users/me/switch-organization): auth-service does not
 * move a session that already has an organisation. The browser then opens
 * the answer's home_url. Null when the switch fails or the answer names no
 * home, so the caller keeps its own landing (the sign-in answer's
 * redirect_url, then GET /session home_url). Login UI derives no address.
 */
export async function homeAfterAcceptance(
  acceptance: InvitationAcceptance | null | undefined,
  switchOrganization: (organizationId: string) => Promise<boolean>,
): Promise<string | null> {
  if (!acceptance) return null
  if (acceptance.organizationId && !(await switchOrganization(acceptance.organizationId))) {
    return null
  }
  return acceptance.homeUrl ?? null
}
